import React, { PropTypes } from 'react'
import Toggle from 'material-ui/Toggle'

const styles = {
  wrapper: {
    maxWidth: '200px',
    marginTop: '1em'
  }
}

const DateToggle = ({ label, value, onChange }) => {
  const toggled = !!value

  const handleToggle = event => {
    if (toggled) {
      onChange(event, null)
    } else {
      onChange(event, new Date())
    }
  }

  return (
    <div style={styles.wrapper}>
      <Toggle
        label={label}
        labelPosition='right'
        toggled={toggled}
        onToggle={handleToggle}
      />
    </div>
  )
}

// @ts-ignore
DateToggle.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default DateToggle
